export default [
  {
    path: 'organization-dashboard',
    name: 'organizationDashboard',
    component: () => import('@/views/Organization/OrganizationDashboard/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'organization-dashboard',
      template: 'auth',
    },
  },
  {
    path: 'factory-dashboard',
    name: 'factoryDashboard',
    component: () => import('@/views/Organization/OrganizationFactoryDashboard/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'factory-dashboard',
      template: 'auth',
    },
  },
];
